import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main_work" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "年份：", -1)
const _hoisted_7 = { class: "header_nr flexAlign" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "月份：", -1)
const _hoisted_9 = { class: "header_nr flexAlign" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "项目名称：", -1)
const _hoisted_11 = { class: "header_nr flexAlign" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "姓名：", -1)
const _hoisted_13 = {
  class: "header_nr flexAlign",
  style: {"margin-left":"20px"}
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"60px","text-align":"left","margin":"10px","font-weight":"600"} }, [
  /*#__PURE__*/_createElementVNode("div", null, "日历"),
  /*#__PURE__*/_createElementVNode("div", { style: {"border-bottom":"3px solid #0585fc","margin":"0 5px"} })
], -1)
const _hoisted_16 = { id: "rltable" }
const _hoisted_17 = { class: "rltd" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("1")
const _hoisted_19 = { class: "rltd" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("2")
const _hoisted_21 = { class: "rltd" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("3")
const _hoisted_23 = { class: "rltd" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("4")
const _hoisted_25 = { class: "rltd" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("5")
const _hoisted_27 = { class: "rltd" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("6")
const _hoisted_29 = { class: "rltd" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("7")
const _hoisted_31 = { class: "rltd" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("8")
const _hoisted_33 = { class: "rltd" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("9")
const _hoisted_35 = { class: "rltd" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("10")
const _hoisted_37 = { class: "rltd" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("11")
const _hoisted_39 = { class: "rltd" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("12")
const _hoisted_41 = { class: "rltd" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("13")
const _hoisted_43 = { class: "rltd" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("14")
const _hoisted_45 = { class: "rltd" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("15")
const _hoisted_47 = { class: "rltd" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("16")
const _hoisted_49 = { class: "rltd" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("17")
const _hoisted_51 = { class: "rltd" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("18")
const _hoisted_53 = { class: "rltd" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("19")
const _hoisted_55 = { class: "rltd" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode("20")
const _hoisted_57 = { class: "rltd" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("21")
const _hoisted_59 = { class: "rltd" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode("22")
const _hoisted_61 = { class: "rltd" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode("23")
const _hoisted_63 = { class: "rltd" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode("24")
const _hoisted_65 = { class: "rltd" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode("25")
const _hoisted_67 = { class: "rltd" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode("26")
const _hoisted_69 = { class: "rltd" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode("27")
const _hoisted_71 = { class: "rltd" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode("28")
const _hoisted_73 = { class: "rltd" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode("29")
const _hoisted_75 = { class: "rltd" }
const _hoisted_76 = /*#__PURE__*/_createTextVNode("30")
const _hoisted_77 = { class: "rltd" }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("td", { class: "rltd" }, null, -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("td", { class: "rltd" }, null, -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("td", { class: "rltd" }, null, -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("td", { class: "rltd" }, null, -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"80px","text-align":"left","margin":"10px","font-weight":"600"} }, [
  /*#__PURE__*/_createElementVNode("div", null, "日历内容"),
  /*#__PURE__*/_createElementVNode("div", { style: {"border-bottom":"3px solid #0585fc","margin":"0 5px"} })
], -1)
const _hoisted_85 = { style: {"font-weight":"600"} }
const _hoisted_86 = { style: {"color":"#979797"} }
const _hoisted_87 = { style: {"margin":"10px 0px"} }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = ["href", "download"]
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"120px","text-align":"left","margin":"10px","font-weight":"600"} }, [
  /*#__PURE__*/_createElementVNode("div", null, "项目跟进日志"),
  /*#__PURE__*/_createElementVNode("div", { style: {"border-bottom":"3px solid #0585fc","margin":"0 5px"} })
], -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_92 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_94 = { class: "flexLeft" }
const _hoisted_95 = /*#__PURE__*/_createTextVNode("提交日志")

import { requestMyuser,apiName} from '@/api/api';
	import { requestProjectList,requestMyTaskList,requestMyShrTaskList,requestProjectAllList,xmUser,requestProjectLog,requestAddProjectlog,requestProjectLogDayList } from '@/api/xmApi';
	import { ref,onMounted,nextTick,computed } from 'vue';
	import { useRouter } from 'vue-router';
	import TaskList from '@/components/TaskList.vue'
	import TaskDetails from '@/components/TaskDetails.vue';
	import AddProjectlog from '@/components/AddProjectlog.vue';
	import type { UploadUserFile } from 'element-plus';
	import { ElMessage } from 'element-plus';
	
export default /*#__PURE__*/_defineComponent({
  name: 'projectfollowup',
  emits: ['toClick'],
  setup(__props, { emit }) {

	const taskShow = ref<boolean>(false)
	const taskDetails = ref(false)//控制弹窗
	const taskDetailsShow = ref(false)//控制弹窗
	const tasklistShow = ref(false)//控制更多列表弹窗
	const month31 = ref(false)//控制更多列表弹窗
	const fileList = ref<UploadUserFile[]>([])
	const api = ref<string>(apiName)
	const form = ref({})
	const self = ref({})
	const userlist = ref([])
	const projectlist = ref([])
	const projectlogdaylist = ref([])
	const projectuuid=ref("")
	const userid=ref("")
	const router = useRouter()
	
	const taskList = ref([])
	const yuqitaskList = ref([])
	const taskShrList = ref([])
	const xmList = ref([])
	const taskType = ref("")
	const projectnr = ref({})//项目
	const logDetails = ref<boolean>(false)//打开日志
	const logDetailsShow = ref<boolean>(false)
	const to = () => {
		emit('toClick',{name:'项目管理',path:'/project'})
	}
	const projectlognum = ref([{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0},{"num":0}])
	//
	const Add = ref({
		projectuuid:"",
		updateremark:"",
		adddate:"",
		userid:""
	})
	const search = ref({
		year:0,
		month:0,
		status:0,
		projectname:"",
		operatorname:"",
		startdate1:"",
		startdate2:"",
		type1:0,
		userid:"",
		projectuuid:""
	})
	//
	const getType = computed(()=>{
		return function(status:number){
			let b = {
				1:"primary",
				2:"danger",
				3:"warning",
				4:"success"
			}
			return b[status]
		}
	})
	onMounted(()=>{
		getMyTask();
		getList();
		getSelf();
		getallprojectList();
		getalluserlist();

		var nowdate = new Date();
		search.value.year=nowdate.getFullYear();
		search.value.month=nowdate.getMonth() + 1;
	})
	const submit = (day: number) =>{
		let fjArr:any[] = []
		fileList.value.forEach((val:any)=>{
			fjArr.push(val.response.data[0].url)
		})
		if(Add.value.projectuuid === ""){
			ElMessage.error("请选择项目");
			return
		}
		if(Add.value.updateremark === ""){
			ElMessage.error("请输入项目日志");
			return
		}
		requestAddProjectlog({
			projectuuid:Add.value.projectuuid ,
			updateremark:Add.value.updateremark,
			adddate:Add.value.adddate,
			userid:Add.value.userid,
			updatestatus:1,
			filelist:fjArr.join(",")
		}).then((res:any)=>{
			ElMessage({
				message: res.msg,
				type: 'success',
				duration: 500
			});
			setTimeout(()=>{
				rlProjectLog()
			},500)
		})
	}
	const dayProjectLog = (day: number) =>{
		requestProjectLogDayList({
			year:search.value.year,
			month:search.value.month,
			day:day,
			projectuuid:search.value.projectuuid,
			updateid:search.value.userid,
		}).then((res:any)=>{
			projectlogdaylist.value=res.datalist;
		})
	}
	const rlProjectLog = () => {
		if(search.value.month==1||search.value.month==3||search.value.month==5||search.value.month==7||search.value.month==8||search.value.month==10||search.value.month==12){
			month31.value=true;
		}else{
			month31.value=false;
		}
		requestProjectLog({
			year:search.value.year,
			month:search.value.month,
			projectuuid:search.value.projectuuid,
			updateid:search.value.userid,
		}).then((res:any)=>{
			projectlognum.value=res.datalist;
		})
	}
	const getalluserlist = () => {
		xmUser({}).then((res:any)=>{
			userlist.value=res.datalist;
			rlProjectLog()
		})
	}
	const getSelf = () => {
		requestMyuser({}).then((res:any)=>{
			self.value=res.datalist[0];
			//search.value.userid=self.value.id;
		})
	}
	const getallprojectList = () => {
		requestProjectAllList({}).then((res:any)=>{
			projectlist.value=res.datalist;
		})
	}
	
	//打击查看日志
	const lookLog = (row: any) => {
		projectnr.value = row.cell
		logDetailsShow.value = false
		nextTick(()=>{
			logDetailsShow.value = true
		})
		logDetails.value = true
	}
	//刷新列表
	const taskListsx = () => {
		getMyTask();
		taskDetails.value = false
	}
	//任务详情
	const taskxq = (row: any) => {
		router.push({name:'TaskList',params:{taskid:parseInt(row.cell.id)}})
	}
	const details = (row:any) => {
		form.value = row.cell
		taskDetailsShow.value = false
		nextTick(()=>{
			taskDetailsShow.value = true
		})
		taskDetails.value = true
	}
	const getMyTask = () => {
		requestMyTaskList({
			pageIndex:1,
			pageSize:10,
			status:1
		}).then((res:any)=>{
			for(var i=0;i<res.data.length;i++){
				if(res.data[i].cell.operatorreadtime==""){
					res.data[i].cell.operatorreadtime1="未读"
				}else{
					res.data[i].cell.operatorreadtime1="已读"
				}
			}
			taskList.value = res.data
		})
		requestMyTaskList({
			pageIndex:1,
			pageSize:10,
			status:1,
			yuqi:1
		}).then((res:any)=>{
			for(var i=0;i<res.data.length;i++){
				if(res.data[i].cell.operatorreadtime==""){
					res.data[i].cell.operatorreadtime1="未读"
				}else{
					res.data[i].cell.operatorreadtime1="已读"
				}
			}
			yuqitaskList.value = res.data
		})

	}
	const getList = () =>{
		requestProjectList({
			pageIndex:1,
			pageSize:10,
			status:1
		}).then((res:any)=>{
			xmList.value = res.data
		})
	}
	const more = (type:string) => {
		taskType.value = type
		tasklistShow.value = false
		nextTick(()=>{
			tasklistShow.value = true
		})
		taskShow.value = true
	}
	const type1tostring = (val: number) =>{
		if(val==1){
			return  "项目售前"
		}
		if(val==2){
			return  "项目售中"
		}
		if(val==3){
			return  "项目售后"
		}
		if(val==4){
			return  "公司内部项目"
		}
		if(val==5){
			return  "周计划投产"
		}
		return "";
	}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_select, {
              modelValue: search.value.year,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.year) = $event)),
              size: "small",
              placeholder: "请选择",
              style: {"width":"80px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "2025",
                  value: 2025
                }),
                _createVNode(_component_el_option, {
                  label: "2026",
                  value: 2026
                }),
                _createVNode(_component_el_option, {
                  label: "2027",
                  value: 2027
                }),
                _createVNode(_component_el_option, {
                  label: "2028",
                  value: 2028
                }),
                _createVNode(_component_el_option, {
                  label: "2029",
                  value: 2029
                }),
                _createVNode(_component_el_option, {
                  label: "2030",
                  value: 2030
                }),
                _createVNode(_component_el_option, {
                  label: "2031",
                  value: 2031
                }),
                _createVNode(_component_el_option, {
                  label: "2032",
                  value: 2032
                }),
                _createVNode(_component_el_option, {
                  label: "2033",
                  value: 2033
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_select, {
              onchange: "changemonth",
              modelValue: search.value.month,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.value.month) = $event)),
              size: "small",
              placeholder: "请选择",
              style: {"width":"80px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "01",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "02",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "03",
                  value: 3
                }),
                _createVNode(_component_el_option, {
                  label: "04",
                  value: 4
                }),
                _createVNode(_component_el_option, {
                  label: "05",
                  value: 5
                }),
                _createVNode(_component_el_option, {
                  label: "06",
                  value: 6
                }),
                _createVNode(_component_el_option, {
                  label: "07",
                  value: 7
                }),
                _createVNode(_component_el_option, {
                  label: "08",
                  value: 8
                }),
                _createVNode(_component_el_option, {
                  label: "09",
                  value: 9
                }),
                _createVNode(_component_el_option, {
                  label: "10",
                  value: 10
                }),
                _createVNode(_component_el_option, {
                  label: "11",
                  value: 11
                }),
                _createVNode(_component_el_option, {
                  label: "12",
                  value: 12
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_select, {
              size: "small",
              filterable: "",
              modelValue: search.value.projectuuid,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.value.projectuuid) = $event)),
              placeholder: "请选择",
              style: {"width":"100px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectlist.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: `${item.code}-${item.projectname}(${type1tostring(item.type1)})`,
                    value: `${item.uuid}`,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_el_select, {
              size: "small",
              filterable: "",
              modelValue: search.value.userid,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search.value.userid) = $event)),
              placeholder: "请选择",
              style: {"width":"100px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userlist.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: `${item.name}`,
                    value: `${item.id}`,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              size: "small",
              icon: _ctx.Search,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (rlProjectLog()))
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["icon"])
          ])
        ])
      ])
    ]),
    _hoisted_15,
    _createElementVNode("table", _hoisted_16, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_17, [
          _hoisted_18,
          (projectlognum.value[0].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (dayProjectLog(1)))
              }, _toDisplayString(projectlognum.value[0].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_19, [
          _hoisted_20,
          (projectlognum.value[1].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (dayProjectLog(2)))
              }, _toDisplayString(projectlognum.value[1].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_21, [
          _hoisted_22,
          (projectlognum.value[2].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (dayProjectLog(3)))
              }, _toDisplayString(projectlognum.value[2].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_23, [
          _hoisted_24,
          (projectlognum.value[3].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (dayProjectLog(4)))
              }, _toDisplayString(projectlognum.value[3].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_25, [
          _hoisted_26,
          (projectlognum.value[4].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (dayProjectLog(5)))
              }, _toDisplayString(projectlognum.value[4].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_27, [
          _hoisted_28,
          (projectlognum.value[5].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (dayProjectLog(6)))
              }, _toDisplayString(projectlognum.value[5].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_29, [
          _hoisted_30,
          (projectlognum.value[6].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (dayProjectLog(7)))
              }, _toDisplayString(projectlognum.value[6].num), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_31, [
          _hoisted_32,
          (projectlognum.value[7].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (dayProjectLog(8)))
              }, _toDisplayString(projectlognum.value[7].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_33, [
          _hoisted_34,
          (projectlognum.value[8].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (dayProjectLog(9)))
              }, _toDisplayString(projectlognum.value[8].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_35, [
          _hoisted_36,
          (projectlognum.value[9].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (dayProjectLog(10)))
              }, _toDisplayString(projectlognum.value[9].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_37, [
          _hoisted_38,
          (projectlognum.value[10].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (dayProjectLog(11)))
              }, _toDisplayString(projectlognum.value[10].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_39, [
          _hoisted_40,
          (projectlognum.value[11].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (dayProjectLog(12)))
              }, _toDisplayString(projectlognum.value[11].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_41, [
          _hoisted_42,
          (projectlognum.value[12].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (dayProjectLog(13)))
              }, _toDisplayString(projectlognum.value[12].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_43, [
          _hoisted_44,
          (projectlognum.value[13].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (dayProjectLog(14)))
              }, _toDisplayString(projectlognum.value[13].num), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_45, [
          _hoisted_46,
          (projectlognum.value[14].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (dayProjectLog(15)))
              }, _toDisplayString(projectlognum.value[14].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_47, [
          _hoisted_48,
          (projectlognum.value[15].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (dayProjectLog(16)))
              }, _toDisplayString(projectlognum.value[15].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_49, [
          _hoisted_50,
          (projectlognum.value[16].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (dayProjectLog(17)))
              }, _toDisplayString(projectlognum.value[16].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_51, [
          _hoisted_52,
          (projectlognum.value[17].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (dayProjectLog(18)))
              }, _toDisplayString(projectlognum.value[17].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_53, [
          _hoisted_54,
          (projectlognum.value[18].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (dayProjectLog(19)))
              }, _toDisplayString(projectlognum.value[18].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_55, [
          _hoisted_56,
          (projectlognum.value[19].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (dayProjectLog(20)))
              }, _toDisplayString(projectlognum.value[19].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_57, [
          _hoisted_58,
          (projectlognum.value[20].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (dayProjectLog(21)))
              }, _toDisplayString(projectlognum.value[20].num), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_59, [
          _hoisted_60,
          (projectlognum.value[21].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[26] || (_cache[26] = ($event: any) => (dayProjectLog(22)))
              }, _toDisplayString(projectlognum.value[21].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_61, [
          _hoisted_62,
          (projectlognum.value[22].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[27] || (_cache[27] = ($event: any) => (dayProjectLog(23)))
              }, _toDisplayString(projectlognum.value[22].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_63, [
          _hoisted_64,
          (projectlognum.value[23].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[28] || (_cache[28] = ($event: any) => (dayProjectLog(24)))
              }, _toDisplayString(projectlognum.value[23].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_65, [
          _hoisted_66,
          (projectlognum.value[24].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[29] || (_cache[29] = ($event: any) => (dayProjectLog(25)))
              }, _toDisplayString(projectlognum.value[24].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_67, [
          _hoisted_68,
          (projectlognum.value[25].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[30] || (_cache[30] = ($event: any) => (dayProjectLog(26)))
              }, _toDisplayString(projectlognum.value[25].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_69, [
          _hoisted_70,
          (projectlognum.value[26].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[31] || (_cache[31] = ($event: any) => (dayProjectLog(27)))
              }, _toDisplayString(projectlognum.value[26].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_71, [
          _hoisted_72,
          (projectlognum.value[27].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[32] || (_cache[32] = ($event: any) => (dayProjectLog(28)))
              }, _toDisplayString(projectlognum.value[27].num), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_73, [
          _hoisted_74,
          (projectlognum.value[28].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[33] || (_cache[33] = ($event: any) => (dayProjectLog(29)))
              }, _toDisplayString(projectlognum.value[28].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_75, [
          _hoisted_76,
          (projectlognum.value[29].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "numlabel",
                onClick: _cache[34] || (_cache[34] = ($event: any) => (dayProjectLog(30)))
              }, _toDisplayString(projectlognum.value[29].num), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_77, [
          (month31.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_78, "31"))
            : _createCommentVNode("", true),
          (projectlognum.value[30].num!=0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "numlabel",
                onClick: _cache[35] || (_cache[35] = ($event: any) => (dayProjectLog(31)))
              }, _toDisplayString(projectlognum.value[30].num), 1))
            : _createCommentVNode("", true)
        ]),
        _hoisted_79,
        _hoisted_80,
        _hoisted_81,
        _hoisted_82
      ])
    ]),
    _hoisted_83,
    _hoisted_84,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectlogdaylist.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        style: {"padding":"10px 5px","border-bottom":"1px solid #b9b9b9"}
      }, [
        _createElementVNode("div", _hoisted_85, [
          _createTextVNode("(" + _toDisplayString(type1tostring(item.projecttype1)) + ")" + _toDisplayString(item.projectname) + "   " + _toDisplayString(item.updatename) + ":", 1),
          _createElementVNode("span", _hoisted_86, _toDisplayString(item.updatetime), 1)
        ]),
        _createElementVNode("div", _hoisted_87, _toDisplayString(item.updateremark), 1),
        (item.filelist!='')
          ? (_openBlock(), _createElementBlock("p", _hoisted_88, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.filelist.split(','), (v, i) => {
                return (_openBlock(), _createElementBlock("a", {
                  href: `${api.value}${v}`,
                  download: `${api.value}${v}`,
                  target: "_blank",
                  key: i,
                  style: {"margin-right":"10px"}
                }, [
                  _createVNode(_component_el_icon, {
                    size: 36,
                    color: "#409EFF"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Document)
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_89))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _hoisted_90,
    _createElementVNode("div", null, [
      _createVNode(_component_el_form_item, { label: "项目名称" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            size: "small",
            filterable: "",
            modelValue: Add.value.projectuuid,
            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((Add.value.projectuuid) = $event)),
            placeholder: "请选择",
            style: {"width":"200px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectlist.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: `${item.code}-${item.projectname}(${type1tostring(item.type1)})`,
                  value: `${item.uuid}`,
                  key: index
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "跟进内容" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: Add.value.updateremark,
            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((Add.value.updateremark) = $event)),
            style: {"width":"400px"}
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "补写日期" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_date_picker, {
            modelValue: Add.value.adddate,
            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((Add.value.adddate) = $event)),
            type: "date",
            placeholder: "补写日期",
            "value-format": "YYYY-MM-DD"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "同步任务" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            size: "small",
            filterable: "",
            modelValue: Add.value.userid,
            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((Add.value.userid) = $event)),
            placeholder: "请选择",
            style: {"width":"100px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "不指派",
                value: ""
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userlist.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: `${item.name}`,
                  value: `${item.id}`,
                  key: index
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _hoisted_91,
      _createVNode(_component_el_upload, {
        action: `${api.value}/frame/uploadfile1`,
        "file-list": fileList.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small"
          }, {
            default: _withCtx(() => [
              _hoisted_92
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["action", "file-list"]),
      _hoisted_93,
      _createElementVNode("div", _hoisted_94, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[40] || (_cache[40] = ($event: any) => (submit())),
          round: ""
        }, {
          default: _withCtx(() => [
            _hoisted_95
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})